var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "m-t-5 m-b-10" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-success btn-sm",
          attrs: {
            "data-cy": "button-add-adjustment",
            disabled: _vm.showAddAdjustmentButton || _vm.hasModifierLimit,
            type: "button"
          },
          on: { click: _vm.onAddAdjustmentButtonClick }
        },
        [
          _c("i", { staticClass: "typcn typcn-plus" }),
          _vm._v(" "),
          _c("span", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "BUTTON_ADD_NEW_ADJUSMENT",
                expression: "'BUTTON_ADD_NEW_ADJUSMENT'"
              }
            ]
          })
        ]
      ),
      _vm._v(" "),
      _vm.value.length > 0
        ? _c(
            "button",
            {
              staticClass: "btn btn-danger btn-sm m-l-15",
              attrs: { disabled: _vm.showAddAdjustmentButton, type: "button" },
              on: { click: _vm.onResetAdjustments }
            },
            [
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "BUTTON_RESET_ADJUSMENTS",
                    expression: "'BUTTON_RESET_ADJUSMENTS'"
                  }
                ]
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.adjustmentsChanged
        ? _c(
            "button",
            {
              staticClass: "btn btn-danger btn-sm m-l-15",
              attrs: { disabled: _vm.showAddAdjustmentButton, type: "button" },
              on: { click: _vm.onCancelAdjustments }
            },
            [
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "BUTTON_CANCEL_NEW_ADJUSMENTS",
                    expression: "'BUTTON_CANCEL_NEW_ADJUSMENTS'"
                  }
                ]
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "clearfix" }),
    _vm._v(" "),
    _vm.hasModifierLimit
      ? _c(
          "div",
          { staticClass: "bs-callout bs-callout-sm bs-callout-warning m-t-0" },
          [
            _c("p", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "MESSAGE_BID_MODIFIER_LIMIT",
                  expression: "'MESSAGE_BID_MODIFIER_LIMIT'"
                }
              ]
            })
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "draggable-table-overflow-x" },
      [
        _c(
          "div",
          {
            staticClass:
              "bid-adjustment-stgs-list__header bid-adjustment-settings-summary"
          },
          [
            _c(
              "div",
              { staticClass: "bid-adjustment-settings-summary__basic-info" },
              [
                _vm._m(0),
                _vm._v(" "),
                _vm._l(_vm.headers, function(header) {
                  return _c(
                    "span",
                    {
                      key: header.property,
                      class:
                        "bid-adjustment-settings-summary__" + header.property
                    },
                    [_vm._v(_vm._s(header.name))]
                  )
                })
              ],
              2
            )
          ]
        ),
        _vm._v(" "),
        _c("SortableList", {
          on: { onOrderChange: _vm.onOrderChange },
          scopedSlots: _vm._u(
            [
              {
                key: "default",
                fn: function({ tableRows }) {
                  return [
                    _c(
                      "div",
                      [
                        _vm.showAddAdjustmentButton
                          ? _c(
                              "AddAdjustment",
                              _vm._b(
                                {
                                  attrs: {
                                    "edit-adjustment":
                                      _vm.editRow &&
                                      _vm.showAddAdjustmentButton,
                                    "current-row": _vm.currentRow
                                  },
                                  on: {
                                    onShowAddAdjustmentChange:
                                      _vm.onAddAdjustmentButtonClick,
                                    onAddAdjustment: _vm.onAddAdjustment,
                                    onEditAdjustment: _vm.onEditAdjustment
                                  }
                                },
                                "AddAdjustment",
                                _vm.editRow
                                  ? _vm.rowOptions
                                  : _vm.adjustmentPanelProperties,
                                false
                              )
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.showAddAdjustmentButton && tableRows.length < 1
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "bid-adjustment-stgs-list__item bid-adjustment-settings-summary bid-adjustment-settings-no-adjustments"
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.noRowText) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(tableRows, function(row) {
                          return _c(
                            "SortableItem",
                            {
                              key: row.id,
                              staticClass:
                                "bid-adjustment-stgs-list__item bid-adjustment-stgs-list__sortable sortable-item",
                              class: {
                                "draggable-table-cursor": !_vm.showAddAdjustmentButton
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "bid-adjustment-settings-summary",
                                  class: {
                                    "bid-adjustment-settings-summary__basic-info-row-fade-in":
                                      _vm.lastRowId == row.id
                                  }
                                },
                                [
                                  _c(
                                    "SortableHandle",
                                    {
                                      class: {
                                        "sortable-handle": !_vm.showAddAdjustmentButton
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "bid-adjustment-settings-summary__basic-info"
                                        },
                                        [
                                          _vm._t("sanitizedRow", null, {
                                            row: row
                                          }),
                                          _vm._v(" "),
                                          _vm._t("actions", null, {
                                            row: row,
                                            showRowAdjustment:
                                              _vm.showRowAdjustment
                                          })
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]
                }
              }
            ],
            null,
            true
          ),
          model: {
            value: _vm.value,
            callback: function($$v) {
              _vm.value = $$v
            },
            expression: "value"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "draggable__dragbutton text-nowrap invisible" },
      [
        _c("span", { staticClass: "draggable__dragbutton-action" }, [
          _c("i", {
            staticClass: "glyphicon glyphicon-option-vertical",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("i", {
            staticClass: "glyphicon glyphicon-option-vertical",
            attrs: { "aria-hidden": "true" }
          })
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }